import { ImageContainer } from '@uaveiro/ui'
import { generatePortalImageSrc } from 'services/generators'
import { withPortalProviders } from 'modules/utils';

export const getDefault = () => {
  const schema = {
    name: 'Image',
    height: '300px',
    isVector: false,
    data: {
      url: 'https://www.ua.pt/contents/imgs/about/campus.jpg'
    }
  }
  return schema
}

export const generateModule = props => {
  const { data, ...rest } = props
  const { url } = data
  const imageProps = {
    width: '100%',
    ...data,
    url: generatePortalImageSrc(url),
    ...rest,
  }
  return withPortalProviders(ImageContainer, imageProps)
}
